import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { PowerBIWorkspaceLinkedService as PowerBIWorkspaceLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PowerBIWorkspaceLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                workspaceID: '*',
                tenantID: '*'
            }
        }
    }
})
export class PowerBIWorkspaceLinkedServiceAdapter extends LinkedServiceAdapter<PowerBIWorkspaceLinkedService> {
    protected modelConstructor(): new () => PowerBIWorkspaceLinkedService {
        return PowerBIWorkspaceLinkedService;
    }

    protected model(): IModel {
        return PowerBIWorkspaceLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: PowerBIWorkspaceLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.PowerBIWorkspaceLinkedService;
        properties.type = Metamodel.modelFor(PowerBIWorkspaceLinkedService).name;
        properties.typeProperties = {
            workspaceID: linkedService.workspaceID,
            tenantID: linkedService.tenantID
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: PowerBIWorkspaceLinkedService): Promise<PowerBIWorkspaceLinkedService> {
        const properties = linkedServiceResource.properties as Model.PowerBIWorkspaceLinkedService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const typeProperties: Model.PowerBIWorkspaceLinkedServiceTypeProperties = properties.typeProperties;
        linkedService.workspaceID = typeProperties.workspaceID;
        linkedService.tenantID = typeProperties.tenantID;
        return linkedService;
    }
}
